module.exports = __webpack_public_path__ + "media/customizations/sunbridge/logo-new-ac426b04c140982ba79b9b5efc06525c.png";